import { Skeleton } from 'antd';
import {
  CaretDownOutlined,
  IconProps,
  Select,
  SelectOption,
} from 'farmhub-ui-core';

import { theme } from 'styled';
import { SELECT_MODE } from 'utils/constants';
import { filterOption } from 'utils/function';

interface CSelectProps {
  id?: string;
  loading?: boolean;
  loadingWidth?: string | number;
  loadingHeight?: string | number;
  placeholder?: string;
  icon?: IconProps;
  containerId?: string;
  value?: any;
  width?: string;
  height?: 'xs' | 'sm' | 'md' | 'lg';
  styles?: any;
  color?: string;
  weight?: string;
  disabled?: boolean;
  defaultValue?: any;
  showSearch?: boolean;
  filterOption?: any;
  list?: Array<any>;
  notFoundContent?: React.ReactNode;
  allowClear?: boolean;
  dropdownMatchSelectWidth?: boolean | number;
  dropdownStyle?: React.CSSProperties;
  children?: React.ReactNode;
  optionLabelProp?: string;
  mode?: 'multiple' | 'tags' | undefined;
  tagRender?: any;
  ref?: any;
  onFocus?: () => void;
  onChange?: (value: any) => void;
  onSearch?: (value: any) => void;
  onPopupScroll?: (e: any) => void;
}

const CSelect = ({
  loading = false,
  list = [],
  icon,
  height = 'md',
  mode,
  children,
  defaultValue,
  loadingWidth,
  loadingHeight,
  showSearch = true,
  ...props
}: CSelectProps): JSX.Element => (
  <>
    {loading ? (
      <Skeleton.Input
        style={{
          width: loadingWidth || 178,
          height: loadingHeight || 34,
          borderRadius: '6px',
        }}
      />
    ) : (
      <Select
        loading
        allowClear={mode === SELECT_MODE.MULTIPLE}
        defaultValue={defaultValue}
        filterOption={(input: string, option: any) =>
          filterOption(input, option)
        }
        height={theme.select.height[height]}
        icon={{ children: <CaretDownOutlined /> }}
        maxTagCount={mode === SELECT_MODE.MULTIPLE ? 'responsive' : undefined}
        mode={mode}
        placeholder={props.placeholder}
        showSearch={showSearch}
        {...props}
      >
        {children ||
          (list.length > 0 &&
            list.map((item: any, index: number) => (
              <SelectOption
                key={item.value}
                label={item.label || item.name}
                value={item.value}
              >
                {item.name}
              </SelectOption>
            )))}
      </Select>
    )}
  </>
);

export default CSelect;
